// extracted by mini-css-extract-plugin
module.exports = {"list":"browse-BrowseEpochs__list--1oCEG","listElement":"browse-BrowseEpochs__listElement--2o5Zj"};